import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useAppLink } from '../../hooks';
import { OverridableButton } from '../Button';
export const AppLinkButton = forwardRef(function LinkButton(props, ref) {
    const AppLink = useAppLink();
    return _jsx(OverridableButton, { ref: ref, component: AppLink, ...props });
});
